var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"134080aef48687fdfe8241110091bcd6ff2f20d3"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import { SENTRY_DSN, isSentryEnabled } from './constants/sentry'

Sentry.init({
  environment: process.env.NEXT_PUBLIC_ENV,
  dsn: SENTRY_DSN,
  enabled: isSentryEnabled,

  ignoreErrors: [
    'ResizeObserver loop completed with undelivered notifications',
    'Turnstile'
  ],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  tracesSampleRate: 0.001,
  debug: false
})
